export default {
  RESERVATION: 'RESERVATION',
  CANCEL_RESERVATION: 'CANCEL_RESERVATION',
  RENTAL_PERIOD: 'RENTAL_PERIOD',
  MONTHS_TO_SKIP_ON_NEXT: 1,
  MONTHS_TO_SKIP_ON_LOAD: 2,
};
